import {Stack} from '../../layout/stack/stack';
import type {JustifyContentOptions, StackSpacing} from '../../layout/stack/stack';

import {CalendarHeatmap} from './calendar-heatmap';
import type {Props as CalendarHeatmapProps} from './calendar-heatmap';
import {groupByMonth} from './helpers';

type Props = {
    heatmapProps: CalendarHeatmapProps;
    isHorizontal?: boolean;
    spacing?: StackSpacing;
    justifyContent?: JustifyContentOptions;
};

export function CalendarHeatmapGroup(props: Props) {
    const {spacing = 32, justifyContent = 'center'} = props;
    const groupedDates = groupByMonth(props.heatmapProps.dates);

    return (
        <Stack
            spacing={spacing}
            justifyContent={justifyContent}
            isHorizontal={props.isHorizontal}
            isFullWidth={true}
        >
            {groupedDates.map((monthDates, index) => (
                <CalendarHeatmap key={index} {...props.heatmapProps} dates={monthDates} />
            ))}
        </Stack>
    );
}
